import { DEFAULT_NEW_PAGE_SLUG_RANDOM_LENGTH as u } from "../../constants.js";
import { makeValidPath as p } from "../../utils/makeValidPath.js";
import { API as i } from "../../api/api.js";
const m = (r) => async ({ productData: t, spaceID: e }) => {
  if (!e)
    return;
  const { getState: n } = r, { tokenHandlers: s } = n(), { spacePermissionTokenHandler: o, subscriptionTokenHandler: a } = s, c = Math.random().toString(36).substring(5, 5 + u), d = {
    ...t,
    product_slug: p(`${t.product_name}-${c}`)
  };
  return (await i.getOrCreateInstance().products().create(d, e, o, a)).data;
}, P = (r) => async (t, e) => {
  if (!t)
    return;
  const { getState: n } = r, { tokenHandlers: s } = n(), { spacePermissionTokenHandler: o, subscriptionTokenHandler: a } = s;
  return (await i.getOrCreateInstance().products().query(t, e, o, a)).data;
}, T = (r) => async (t, e) => {
  if (!e || !t)
    return;
  const { getState: n } = r, { tokenHandlers: s } = n(), { spacePermissionTokenHandler: o, subscriptionTokenHandler: a } = s;
  return (await i.getOrCreateInstance().products().get(t, e, o, a)).data;
}, f = (r) => async ({ productID: t, spaceID: e, productData: n }) => {
  if (!e || !t || !n)
    return;
  const { getState: s } = r, { tokenHandlers: o } = s(), { spacePermissionTokenHandler: a, subscriptionTokenHandler: c } = o;
  return (await i.getOrCreateInstance().products().update(t, e, n, a, c)).data;
}, C = (r) => async ({ productID: t, spaceID: e, published: n }) => {
  if (!e || !t)
    return;
  const { getState: s } = r, { tokenHandlers: o } = s(), { spacePermissionTokenHandler: a, subscriptionTokenHandler: c } = o;
  return (await i.getOrCreateInstance().products().publish(t, e, n, a, c)).data;
}, b = (r) => async (t) => {
  if (!t)
    return;
  const { getState: e } = r, { tokenHandlers: n } = e(), { spacePermissionTokenHandler: s, subscriptionTokenHandler: o } = n;
  return (await i.getOrCreateInstance().products().getProductCollection(t, s, o)).data;
}, S = (r) => async ({ spaceID: t, contactEmail: e }) => {
  if (!t || !e)
    return;
  const { getState: n } = r, { tokenHandlers: s } = n(), { spacePermissionTokenHandler: o, subscriptionTokenHandler: a } = s;
  return (await i.getOrCreateInstance().products().updateContactEmail(t, e, o, a)).data;
}, y = (r) => async (t) => {
  if (!t)
    return;
  const { getState: e } = r, { tokenHandlers: n } = e(), { spacePermissionTokenHandler: s, subscriptionTokenHandler: o } = n;
  return (await i.getOrCreateInstance().products().countProducts(t, s, o)).data;
};
export {
  y as countProducts,
  m as createProduct,
  T as getProduct,
  b as getProductCollection,
  C as publishProduct,
  P as queryProducts,
  S as updateContactEmail,
  f as updateProduct
};
